import { render, staticRenderFns } from "./veStuYyproject.vue?vue&type=template&id=58daccb4&scoped=true"
import script from "./veStuYyproject.vue?vue&type=script&lang=js"
export * from "./veStuYyproject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58daccb4",
  null
  
)

export default component.exports